// ======================================================================
// File Name       : LivePerformanceConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const LIVE_FORMAT_STR = [
    { value: 0, name: '双方向' },
    { value: 1, name: '片方向' },
];

export const LIVE_SITUATION = {
  BEFORE_OPEN: 0,
  IN_SESSION: 1,
  AFTER_OPEN: 2,
};

